var map = {
	"./Black-Bishop.svg": 37483,
	"./Black-King.svg": 55446,
	"./Black-Knight.svg": 78256,
	"./Black-Pawn.svg": 84602,
	"./Black-Queen.svg": 22636,
	"./Black-Rook.svg": 67214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48509;